import { buildMessage, matches, MATCHES, ValidateBy } from 'class-validator';
export function MatchesWithLVS(pattern, modifiersOrAnnotationOptions, validationOptions) {
    let modifiers;
    if (modifiersOrAnnotationOptions && modifiersOrAnnotationOptions instanceof Object && !validationOptions) {
        validationOptions = modifiersOrAnnotationOptions;
    }
    else {
        modifiers = modifiersOrAnnotationOptions;
    }
    return ValidateBy({
        name: MATCHES,
        constraints: [pattern, modifiers],
        validator: {
            validate: (value, args) => matches(value, args?.constraints[0], args?.constraints[1]),
            defaultMessage: buildMessage((eachPrefix) => eachPrefix + '$property must match $constraint1 regular expression', validationOptions),
        },
    }, validationOptions);
}
//# sourceMappingURL=MatchesWithLVS.js.map